import { icons } from "~/custom/tinymce/icons/editor_icons";
const useTinyMCESlashAutocomplete = () => {
  const slashDelimiter = `/`;

  const slashOptions = [
    {
      name: "Bullet list",
      type: "bullet_list",
      shortcut: "* text ↵",
      icon: icons["unordered-list"],
      button: "bullist",
    },
    {
      name: "Numbered list",
      type: "numbered_list",
      shortcut: "1. text ↵",
      icon: icons["ordered-list"],
      button: "numlist",
    },
    {
      name: "Table",
      type: "table",
      icon: icons["table"],
      button: "table",
    },
    {
      name: "Image",
      type: "image",
      icon: icons["image"],
      button: "image",
    },
    {
      name: "Link",
      type: "link",
      icon: icons["link"],
      button: "link",
    },
    {
      name: "Divider",
      type: "divider",
      shortcut: "---",
      icon: icons["horizontal-rule"],
      button: "hr",
    },
    {
      name: "Quote",
      type: "quote",
      shortcut: "> text ↵",
      icon: icons["quote"],
      button: "blockquote",
    },
    {
      name: "Code",
      type: "code",
      icon: icons["code-sample"],
      button: "codesample",
    },
    {
      name: "Note",
      type: "note",
      icon: icons["note"],
      button: "note",
    },
    {
      name: "Info",
      type: "info",
      icon: icons["info-icon"],
      button: "calloutinfo",
    },
    {
      name: "Success",
      type: "success",
      icon: icons["checkbox-circle"],
      button: "calloutsuccess",
    },
    {
      name: "Alert",
      type: "alert",
      icon: icons["alert"],
      button: "calloutalert",
    },
    {
      name: "General",
      type: "general",
      icon: icons["info-icon"],
      button: "calloutgeneral",
    },
    {
      name: "Magic",
      type: "magic",
      icon: icons["spark"],
      button: "calloutmagic",
    },
  ];

  const source = (query, process, delimiter) => {
    if (delimiter !== slashDelimiter) {
      return;
    }

    if (slashOptions.length) {
      process(slashOptions);
    }
  };

  const render = (item, delimiter) => {
    if (delimiter !== slashDelimiter) {
      return;
    }
    const shortcut = item?.shortcut ? `<span class="shortcut">${item.shortcut}</span>` : "";

    return `
      <li>
        <a href="javascript:;">
          <div class="a51_autocomplete slash_autocomplete">
            <div class="a51_autocomplete_option">
              <span class="icon slash_icon">${item.icon}</span>
              <span class="name">${item.name}</span>
              ${shortcut}
            </div>
          </div>
        </a>
      </li>
    `;
  };

  const insert = (item, delimiter) => {
    if (delimiter !== slashDelimiter) {
      return;
    }

    return;
  };

  const buttonAction = (item, delimiter) => {
    if (delimiter !== slashDelimiter) {
      return;
    }

    return item?.button ? item.button : null;
  };

  return {
    source,
    render,
    insert,
    buttonAction,
  };
};

export default useTinyMCESlashAutocomplete;
